import xss from 'xss'
import Vue from 'vue'

Object.keys(xss.whiteList).forEach((key) => {
  xss.whiteList[key].push('style', 'class')
})
xss.whiteList.table.push(...['cellpadding', 'cellspacing'])
xss.whiteList.html = []
xss.whiteList.body = []
xss.whiteList.head = []
xss.whiteList.meta = []
xss.whiteList.style = ['type']
xss.whiteList.iframe = ['src', 'width', 'height']

function myXss(resource) {
  return xss(resource, {
    whiteList: xss.whiteList,
    css: false,
    stripIgnoreTagBody: ['script', 'meta']
  })
}

Vue.prototype.$xssFilter = myXss
